/**
 * The paths of the Allocation family's pages, apart from the pages themselves.
 *
 * Link helpers (`proposals-view.ts`, `kpi-links.ts`) need a page's address and nothing else. They
 * import it from here, not from `allocation-pages.tsx`: that module mounts the distribute run
 * picker, and the run-default census (`src/test/run-default-census.test.ts`) walks static imports,
 * so every page reaching a link helper would otherwise count as mounting it.
 */

/** The four pages' paths. The drill patterns stay in `drill.ts`. */
export const ALLOCATION_WHY_PATH = '/inseason/allocation-why';
export const ALLOCATION_STOCK_PATH = '/inseason/allocation-stock';
export const ALLOCATION_DECISIONS_PATH = '/inseason/allocation-decisions';
/**
 * «Tutte le celle dell'esecuzione», the second part of «Proposte» (owner ruling 2026-10-24): the run's
 * cells counted by outcome and the file of every one. A sibling prefix, as the other pages are.
 */
export const ALLOCATION_CELLS_PATH = '/inseason/allocation-cells';
/**
 * «Non inviate», the second part of «Perché» (owner request 2026-10-24): the need the run left without
 * a line, per store × article, and what it lost to. A sibling prefix, as the other pages are.
 */
export const ALLOCATION_NOT_SENT_PATH = '/inseason/allocation-why-not-sent';
